export default function positiveNumber(int) {
	const value = int > 100 ? 100 : int;
	return Math.abs(value);
}
